export default {
  getCountry: state => countryId => state.countries,
};
